import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useAboutData } from '../lib/cmsStore';
export function AboutSection() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    data,
    isLoading
  } = useAboutData();
  const heroTitle = !isLoading && data?.heroTitle ? data.heroTitle : "I'm a product designer and creative technologist specializing in digital experiences, UI systems, and interactive products.";
  const subtitle = !isLoading && data?.subtitle ? data.subtitle : 'My work sits at the intersection of design, programming, and creative experimentation. I enjoy building interfaces, designing systems, and exploring emerging technologies like AI and Web3.';
  const skills = !isLoading && data?.skills.length > 0 ? data.skills.map(s => s.name) : ['UX/UI Design', 'Product Design', 'Design Systems', 'Interaction Design', 'Prototyping', 'Frontend Dev', 'Creative Coding'];
  const tools = !isLoading && data?.tools.length > 0 ? data.tools.map(t => t.name) : ['Figma', 'Framer', 'Webflow', 'After Effects', 'Blender', 'Ableton', 'VS Code'];
  return <section id="about" className="py-24 md:py-40 px-6 md:px-12 border-t border-border" data-id="element-47">
      <div ref={ref} className="max-w-6xl mx-auto" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-49">
          <span className="font-mono text-xs text-primary uppercase tracking-widest" data-id="element-50">
            // About
          </span>
          <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tighter mt-4" data-id="element-51">
            About
          </h2>

          <div className="mt-16 grid md:grid-cols-[2fr_1fr] gap-16" data-id="element-52">
            <div data-id="element-53">
              <p className="font-display text-2xl md:text-4xl font-medium leading-snug tracking-tight whitespace-pre-line" data-id="element-54">
                {heroTitle}
              </p>
              <p className="mt-8 font-mono text-sm text-muted-foreground leading-relaxed max-w-xl whitespace-pre-line" data-id="element-55">
                {subtitle}
              </p>
            </div>

            <div className="space-y-10" data-id="element-56">
              <div data-id="element-57">
                <h3 className="font-mono text-xs text-muted-foreground uppercase tracking-widest mb-4" data-id="element-58">
                  Skills
                </h3>
                <div className="flex flex-wrap gap-2" data-id="element-59">
                  {skills.map(skill => <span key={skill} className="font-mono text-xs px-3 py-1.5 border border-border bg-secondary text-secondary-foreground hover:border-primary hover:text-primary transition-colors cursor-default" data-id="element-60">
                      {skill}
                    </span>)}
                </div>
              </div>

              <div data-id="element-61">
                <h3 className="font-mono text-xs text-muted-foreground uppercase tracking-widest mb-4" data-id="element-62">
                  Tools
                </h3>
                <p className="font-mono text-sm text-foreground" data-id="element-63">
                  {tools.join(' · ')}
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}